export * from './SportPersonRunFastIcon';
export * from './SportPersonRunFastIcon16Light';
export * from './SportPersonRunFastIcon16Regular';
export * from './SportPersonRunFastIcon16Solid';
export * from './SportPersonRunFastIcon20Light';
export * from './SportPersonRunFastIcon20Regular';
export * from './SportPersonRunFastIcon20Solid';
export * from './SportPersonRunFastIcon24Regular';
export * from './SportPersonRunFastIcon24Solid';
export * from './SportPersonRunFastIcon32Regular';
export * from './SportPersonRunFastIcon64Regular';
